import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CustomerPreorderPage from './pages/CustomerPreorderPage';
import CustomerPreorderConfirmationPage from './pages/CustomerPreorderConfirmationPage';
import CustomerPreorderTrackingPage from './pages/CustomerPreorderTrackingPage';
import InstallPrompt from './components/InstallPrompt';

export default function CustomerApp() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-950 text-white">
        <Routes>
          <Route path="/preorders/new" element={<CustomerPreorderPage />} />
          <Route path="/preorders/new/thanks" element={<CustomerPreorderPage />} />
          <Route
            path="/preorders/confirmation/:id"
            element={<CustomerPreorderConfirmationPage />}
          />
          <Route path="/preorders/track" element={<CustomerPreorderTrackingPage />} />
          <Route path="/preorder" element={<Navigate to="/preorders/new" replace />} />
          <Route path="*" element={<Navigate to="/preorders/new" replace />} />
        </Routes>
        <InstallPrompt />
      </div>
    </Router>
  );
}
